import { Children, isValidElement } from "react";
import type { ReactNode } from "react";

import { useFilterPanelContext } from "../../filter-panel.context";
import { APPLY_FILTERS_LABEL } from "../../messages";
import { resolveClearButton } from "../resolve-clear-button";
import { FilterPanelSaveButton } from "../save-button";
import type { FilterPanelFooterProps, FilterPanelFooterViewProps } from "./types-footer";

const isSaveButton = (child: ReactNode) =>
  isValidElement(child) && child.type === FilterPanelSaveButton;

/** ViewModel do FilterPanel.Footer: separa o `SaveButton` dos demais filhos e resolve Limpar/Desfazer e Aplicar; sem JSX. */
export function useFilterPanelFooter({
  children,
  className,
  ...rest
}: FilterPanelFooterProps): FilterPanelFooterViewProps {
  const panel = useFilterPanelContext();
  const items = Children.toArray(children);
  const { isMobile } = panel;

  return {
    className: [panel.classNames.footer, className].filter(Boolean).join(" ") || undefined,
    hidden: panel.collapsed,
    rest,
    isMobile,
    // No mobile, Adicionar e Limpar moram no grupo de linhas (`MobileActions`); o rodapé fica só com Salvar e Aplicar.
    startItems: isMobile ? [] : items.filter((child) => !isSaveButton(child)),
    saveItems: items.filter(isSaveButton),
    clearButton: panel.showClear && !isMobile ? resolveClearButton(panel) : null,
    applyButton: {
      className: panel.classNames.applyButton,
      label: APPLY_FILTERS_LABEL,
      disabled: !panel.canApply,
      onClick: panel.apply,
      testId: panel.partTestId("apply"),
    },
  };
}
